module.exports = __webpack_public_path__ + "static/img/app_ios.6001095.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app_ios.png
// module id = we65
// module chunks = 1